import React, { useState } from "react";
import axios from "axios";
import useIntl from "@/utils/intl";
interface ModalProps {
  isVisible: boolean;
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ isVisible, onClose }) => {
  const { translate } = useIntl();
  const [formData, setFormData] = useState({
    phone: "",
    subject: "Өрхийн интернэт тавиулах захиалга",
  });
  const [isSuccess, setIsSuccess] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { phone, subject } = formData;

    if (!formData.phone) {
      alert("Утасны дугаар оруулна уу.");
      return;
    }

axios
      .post("/api/sendEmail", { data: phone, subject })
      .catch((error) => {
        // Optionally handle error
        console.error("An error occurred:", error);
      });

    setIsSuccess(true);
    setTimeout(() => {
      setIsSuccess(false);
      onClose();
    }, 2000);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-surfaceInverse rounded-lg p-5 w-auto">
      <div className="relative flex flex-row gap-2 items-center justify-between mb-5">
  <h2 className="text-base font-bold text-textHigh">{translate('request.service')}</h2>
  <button
    type="button"
    className="rounded-md p-2 inline-flex items-center justify-center text-textHigh bg-black/5 focus:outline-none focus:ring-2 focus:ring-inset"
    onClick={onClose}
  >
    <span className="sr-only">Close menu</span>
    <svg
      className="h-6 w-6"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      aria-hidden="true"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  </button>
</div>

        <form onSubmit={handleSubmit}>
          <div className="flex flex-row w-full">
            <div>
            <div className="mb-4">
                <label
                  className="block text-textHigh text-sm font-bold mb-2"
                  htmlFor="name"
                >
                  {translate('phoneNumber')}:
                  <span className="text-red-500 ml-1">*</span>
                </label>
                <input
                  id="phone"
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="shadow appearance-none required border rounded w-full py-2 px-3 text-textHigh leading-tight focus:outline-none focus:shadow-outline"
                  required
                  pattern="\d{8}"
                  title="Зөв дугаар оруулна уу."
                />
              </div>
            </div>
          </div>
          <div className="flex items-center w-full justify-center pt-2">
            <button
              type="submit"
              className="bg-red-600 w-full text-white py-1 px-4 rounded-lg hover:bg-red-700 transition-colors duration-100"
            >
              {translate('request.toSend')}
            </button>
          </div>
        </form>
        {isSuccess && (
          <div className="fixed inset-0 bg-black bg-opacity-20 flex justify-center items-center z-60">
            <div className="bg-white rounded-lg p-5">
              <h3 className="text-lg">{translate("request.sent")}</h3>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
